export enum Role {
  SUPER_ADMIN = "SUPER_ADMIN",
  ORGANIZATION_ADMIN = "ORGANIZATION_ADMIN",
  CLUB_ADMIN = "CLUB_ADMIN",
  MEMBER = "MEMBER",
}
